import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    styles: [`
    #homeButton {
        width: 216px;
        height: 46px;
        background-color: #00A698;
        color: #fff;
        font-weight: bold;
        margin-left: auto;
        margin-right: auto;
    }

    .logo {
        margin-left: auto;
        margin-right: auto;
        display: block;
        height: 45px;
    }

    .confirmation-text {
        color: #333333;
        font-family: Arial;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
    }

    .confirmation-description {
        color: #333333;
        font-family: Arial;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
    }

    .icon {
        height: 450px;
        width: 450px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }

    .green-check-icon {
        height: 96px;
        width: 96px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }

    .right-link {
        margin-left: auto;
        text-align: right;
    }

    .links {
        display: flex;
        flex-direction: row;
        color: #009FDE;
        font-family: Arial;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 24px;
        margin-top: 24px;
    }

    .link {
        text-decoration: none;
        color: #009FDE;
    }

    .box {
        background-color: #FFFFFF;
        width: 500px;
        height: auto;
        margin: 0 auto;
        padding: 24px;
        margin-top: 48px;
        text-align: center;
    }

    .policy {
        text-align: center;
        padding-top: 16px;
    }

    .container{
        height: 100%;
        width: 100%;
        background-color: #F4FAFC;
        display: flex;
    }

    .policy-link {
        color: #003952;
        font-family: Arial;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        text-decoration: none;
    }

    .reset-panel{
        padding-top: 60px;
        margin: 0 auto;
        width: 100%;
    }

.standard-text-color {
    color: #333333;
}

.link-text-color {
    color: #009fde;
}

.ToS-text-color {
    color: #003952;
}

.sign-in-button {
    background-color: #00A698;
    color: #fff;
}

#light-mode {
    display: block;
}

#dark-mode {
    display: none;
}

.text{
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}

.small-text{
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}

::ng-deep .en:before {
    background-image: url(/identity/content/icons/usa_flag.png) !important;
}

::ng-deep .br:before {
    background-image: url(/identity/content/icons/brazil_flag.png) !important;
}

::ng-deep .es:before {
    background-image: url(/identity/content/icons/spain_flag.png) !important;
}

::ng-deep .dropdown-icon {
    content: url("/identity/content/icons/dropdown-button.png")
}

@media (prefers-color-scheme: dark) {
    .standard-text-color {
        color: #E6E6E6;
    }

    .box{
        background-color: #333333;
    }

    .ToS-text-color {
        color: #1CA8DD;
    }

    .link-text-color {
        color: #1CA8DD;
    }

    .background {
        background-color: #2A2A2A;
    }

    .sign-in-button {
        background-color: #1CA8DD !important;
        border: 0 !important;
    }

    ::ng-deep.dx-texteditor {
        background-color: #2A2A2A !important;
        border: 1px solid #454545 !important;
    }

    ::ng-deep .dx-field-item-label-text {
        color: #E6E6E6 !important;
    }

    ::ng-deep .dx-texteditor-input{
        color: #E6E6E6;
    }

    #light-mode {
        display: none !important;
    }

    #dark-mode {
        display: block !important;
    }
}
    /* for mobile*/
    @media (max-width: 768px) {
        .box{
            width: calc( 100% - 48px);
        }

        .icon{
            width: 150px;
            height: 150px;
        }
    }

    `],
    template: `
    <div style="height: 100%">
        <ng-container *ngIf="username">
            <div class="container background">
                <div class="reset-panel">
                    <div class="title">
                        <img id="light-mode" class="logo" src="/identity/content/icons/XMPro-Logo2x.png" />
                        <img id="dark-mode" class="logo" src="/identity/content/icons/XMPro-White.png" />
                    </div>
                    <div style=height:24px;></div>
                    <img class="icon" src="/identity/content/icons/password-reset.png" />
                    <div style=height:24px;></div>
                        <p class="standard-text-color text" style="font-family: Arial; word-break: break-word;">{{'Your password has been updated!' | translate}}</p>
                    <p class="standard-text-color small-text" style="padding-top: 8px;">{{'Click below to continue.' | translate}} </p>
                    <br />
                    <div style="margin: auto; text-align: center;" >
                        <a href="/"><div id="homeButton" class="sign-in-button dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-text"><div class="dx-button-content">{{'Return to home page' | translate}}</div></div></a>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!username">
            <div class="container background" >
                <div class="reset-panel">
                    <img id="light-mode" class="logo" src="/identity/content/icons/XMPro-Logo2x.png" />
                    <img id="dark-mode" class="logo" src="/identity/content/icons/XMPro-White.png" />
                    <div class="box">
                        <img style="width: 150px; height: 150px;" src="/identity/content/icons/email-sent.png" />
                        <p class="standard-text-color text" style="padding-top: 30px;">{{'Check your inbox!' | translate}} </p>
                        <p class="standard-text-color text" style="font-family: Arial; word-break: break-word;">{{'We have just sent an email to reset your password.' | translate}}</p>
                        <p class="standard-text-color small-text" style="padding-top: 8px;">{{'Please check this email associated with your account' | translate}}  <span class="confirmation-description link-text-color " style="height: auto; word-break: break-word;"> {{email}} </span>  </p>
                        <div class="links">
                            <div>
                                <a class="link" href="../../">{{'Return to home page' | translate}}</a>
                            </div>
                            <div class="right-link">
                                <a class="link ToS-text-color" href="https://xmpro.com/contact-us/" target="_blank">{{'Contact support' | translate}}</a>
                            </div>
                        </div>
                    </div>
                    <p class="policy">
                        <a class="policy-link ToS-text-color" href="https://xmpro.com/privacy-policy" target="_blank" rel="noopener noreferrer">{{'Privacy Policy' | translate}}</a>
                        <span class="dot" style="margin: auto 0;"> • </span>
                        <a class="policy-link ToS-text-color" href="https://xmpro.com/privacy-policy/" target="_blank" rel="noopener noreferrer">{{'Terms of Service' | translate}}</a>
                    </p>
                </div>
            </div>
        </ng-container>
    </div>
    `,
})
export class ResetPasswordComplete {
    email = "specified email";
    username: string;
    constructor(private _router: Router, private translate: TranslateService, private _route: ActivatedRoute) {
        let cookie = document.cookie.match(new RegExp('(^| )Language=([^;]+)'))
        this.translate.use(cookie && cookie[2] ? cookie[2] : "en");
        this.email = this._route.snapshot.params['email'];
        this.username = this._route.snapshot.params['username'];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Register/ResetPasswordComplete.ts